/*eslint-env node*/
const { linkResolver } = require('./link-resolver');
const { transformFieldName } = require('./transform-field-name');
const HtmlSerializer = require('./html-serializer');

module.exports = {
  linkResolver, transformFieldName,
  htmlSerializer: HtmlSerializer
};
